import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateDaysOff } from "./updateDaysOff.request";
import { UpdateDaysOffBody } from "./updateDaysOff.types";

const useUpdateDaysOff = (
  companyId?: string,
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: (body: UpdateDaysOffBody) =>
      requestUpdateDaysOff(body, companyId),
    onError: toastServerError,
    ...options
  });
};

export default useUpdateDaysOff;
